<template>
  <div>
    <!-- Modal -->
    <div class="modal-overlay" id="modal-overlay" @click="close">

      <div class="modal" id="modal" @click.stop>
        <div class="modal-header">
          <h5 class="modal-title">{{ title }}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"
            @click.prevent="close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body mt-5">

          <slot name="body"></slot>


        </div>
      </div>
    </div>
    <!-- Modal -->
  </div>
</template>

<script>
// import { eventBus } from '../../main'
export default {
    data() {
      return {
      }
    },

    props: {
      title: {
        type: String,
        required: true
      }
    },
    methods: {
      close() {
        this.$emit('close' )
      }
    }

  }
</script>


<style scoped>
.closed {
  display: none;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  background: rgba(0, 0, 0, 0.6);
}

.modal-body {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  overflow: auto;
}

body {
  background-color: #556;
  background-image: linear-gradient(30deg, #445 12%, transparent 12.5%, transparent 87%, #445 87.5%, #445),
    linear-gradient(150deg, #445 12%, transparent 12.5%, transparent 87%, #445 87.5%, #445),
    linear-gradient(30deg, #445 12%, transparent 12.5%, transparent 87%, #445 87.5%, #445),
    linear-gradient(150deg, #445 12%, transparent 12.5%, transparent 87%, #445 87.5%, #445),
    linear-gradient(60deg, #99a 25%, transparent 25.5%, transparent 75%, #99a 75%, #99a),
    linear-gradient(60deg, #99a 25%, transparent 25.5%, transparent 75%, #99a 75%, #99a);
  background-size: 80px 140px;
  background-position: 0 0, 0 0, 40px 70px, 40px 70px, 0 0, 40px 70px;
}

.modal {
    display: block;
    width: 43.75rem;
    max-width: 100%;
    height: 34.375rem;
    max-height: 100%;
    position: fixed;
    z-index: 100;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: white;
    box-shadow: 0 0 3.75rem 0.625rem rgba(0, 0, 0, 0.9);
  }

  .modal-body-content h3 {
    margin: 3.125rem 0 0.3125rem 0;
    color: #1F1F1F;
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .modal-body-content p {
    color: #999999;
    font-size: 1.125rem;
    line-height: 2rem;
  }

  .modal-button {
    margin-top: 1.25rem;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }

  .modal-footer {
    border-top: none;
}


</style>
